import { FC } from "react";
import PrepState100Svg from "../../public/icons/PrepState100.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const GeometryBuildUpPrepState100Icon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><PrepState100Svg/></span>;
